/* HLM card finish-flip: clicking a swatch dot swaps the card's image to that
   finish and repoints the card link at that variant. No navigation. */
(function () {
  document.addEventListener('click', function (e) {
    var dot = e.target.closest('[data-hlm-dot]');
    if (!dot) return;
    e.preventDefault();
    e.stopPropagation();

    var card = dot.closest('product-card, .product-card');
    if (!card) return;

    var img = card.querySelector('.card-gallery img');
    var src = dot.getAttribute('data-img');
    if (img && src) {
      img.removeAttribute('srcset');
      img.src = src;
    }

    var link = card.querySelector('a.product-card__link');
    var vurl = dot.getAttribute('data-variant-url');
    if (link && vurl) link.setAttribute('href', vurl);

    dot.parentElement.querySelectorAll('[data-hlm-dot]').forEach(function (d) {
      d.setAttribute('aria-pressed', d === dot ? 'true' : 'false');
    });
  });
})();

/* The placeholder hero carousel that used to live here (2026-08-25) was
   removed 2026-09-02 -- the hero is now sections/hlm-hero-carousel.liquid,
   pure CSS, driven by image_picker settings. */
